export const MENU_WIDTH = 44;
export const GNB_HEIGHT = 45;
